module.exports = __webpack_public_path__ + "img/tablet-header.83f8f2cd.png";